// TODO: Update other places that use this path to use the new constant
export const DEFAULT_TRACK_ARTWORK_PATH = "/public/default-track-artwork.png";

// Where to send someone who wants the app. `MOBILE_APP_URL` is the catch-all
// landing page; iOS gets sent straight to the App Store. Use
// `getAppDownloadUrl()` rather than these constants directly.
export const MOBILE_APP_URL = "https://www.highnote.fm/app/download";
export const IOS_APP_STORE_URL =
  "https://apps.apple.com/us/app/highnote-fm-listening-clubs/id6535646979";

/**
 * Best-effort iOS detection. There's no official browser API for this, so this
 * is a heuristic:
 * - UA Client Hints (`userAgentData`) when available — but it's Chromium-only,
 *   so it never fires for the WebKit browsers all iOS users are actually on.
 *   Useful mainly to rule iOS *out* on Android/desktop Chrome.
 * - Falls back to UA-string matching, plus the iPadOS 13+ workaround: iPad
 *   Safari reports as "MacIntel", so a Mac platform with touch points is
 *   treated as iOS.
 * When unsure it returns false, so the caller falls through to the generic URL.
 */
const isIOS = (): boolean => {
  const nav = window.navigator as Navigator & {
    userAgentData?: { platform?: string };
  };

  // Chromium exposes the real platform synchronously via `platform`.
  const hintPlatform = nav.userAgentData?.platform;
  if (hintPlatform) return hintPlatform === "iOS";

  if (/iPad|iPhone|iPod/.test(nav.userAgent)) return true;
  // iPadOS 13+ masquerades as macOS; disambiguate with touch support.
  return nav.platform === "MacIntel" && nav.maxTouchPoints > 1;
};

/**
 * Resolves where a "get the app" action should send the user: the App Store on
 * iOS, and the generic landing page otherwise (Android and anything we can't
 * confidently detect). Prefer this over the raw URL constants.
 */
/**
 * The Instagram in-app browser identifies itself in the UA string (no other
 * reliable signal exists). Used by DownloadAppButton to show a copy-link
 * fallback, since IG sometimes chokes the redirect to the app store.
 */
export const isInstagramBrowser = (): boolean =>
  window.navigator.userAgent.indexOf("Instagram") > -1;

export const getAppDownloadUrl = (): string =>
  isIOS() ? IOS_APP_STORE_URL : MOBILE_APP_URL;

const constants = {
  longMaxLength: 500,
  mediumMaxLength: 120,
  shortMaxLength: 50,
  cache: {
    volumeLevelKey: "highnote-volume-level",
    volumeMutedKey: "highnote-volume-muted",
  },
};

export default constants;
